import {
  Navbar,
  HeroSection,
  FeaturesSection,
  TrustSection,
  HowItWorksSection,
  CTASection,
  Footer
} from "../components/landing";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-base-100 text-base-content overflow-x-hidden">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <TrustSection />
        <HowItWorksSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
